module.exports = "/fonts/bitter-v16-latin-ext-600.a284756dc8d734ec52ba34bcfd1946a5.woff";